import { gql } from '@apollo/client';

export interface SupportUploadRecord {
    id: number;
    objectKey: string;
    fileName: string;
    contentType?: string | null;
    fileCategory: string;
    bucketType: number;
    usage?: string | null;
    operatorName?: string | null;
    createdAt?: number | null;
}

export interface RecordSupportUploadVariables {
    input: {
        objectKey: string;
        fileName: string;
        contentType?: string | null;
        bucketType?: number;
        usage?: string | null;
    };
}

export interface RecordSupportUploadResponse {
    recordSupportUpload: SupportUploadRecord;
}

export const RECORD_SUPPORT_UPLOAD = gql`
    mutation RecordSupportUpload($input: RecordSupportUploadInput!) {
        recordSupportUpload(input: $input) {
            id
            objectKey
            fileName
            contentType
            fileCategory
            bucketType
            usage
            operatorName
            createdAt
        }
    }
`;

export interface ListSupportUploadRecordsVariables {
    fileCategory?: string | null;
    pageRequest?: { page?: number; size?: number };
}

export interface ListSupportUploadRecordsResponse {
    listSupportUploadRecords: {
        content: SupportUploadRecord[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}

export const LIST_SUPPORT_UPLOAD_RECORDS = gql`
    query ListSupportUploadRecords($fileCategory: String, $pageRequest: PageRequestTypeInput) {
        listSupportUploadRecords(fileCategory: $fileCategory, pageRequest: $pageRequest) {
            content {
                id
                objectKey
                fileName
                contentType
                fileCategory
                bucketType
                usage
                operatorName
                createdAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;
